var _path, _g, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgNote(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "a",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 4,
    y: 3,
    width: 24,
    height: 29
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.222 3.596h23.544v28.297H4.222V3.596Z",
    fill: "#fff"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M24.09 31.892H7.903a3.685 3.685 0 0 1-3.68-3.681V7.288a3.685 3.685 0 0 1 3.68-3.68h2.304a.637.637 0 1 1 0 1.273H7.903a2.41 2.41 0 0 0-2.408 2.407v20.923a2.41 2.41 0 0 0 2.408 2.407H24.09a2.41 2.41 0 0 0 2.407-2.407V7.288a2.41 2.41 0 0 0-2.407-2.407h-2.376a.637.637 0 1 1 0-1.274h2.377c2.028 0 3.679 1.65 3.679 3.681v20.923c0 2.03-1.65 3.681-3.68 3.681Z",
    fill: "#3461FD"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.877 6.602h10.239V3.505H18.18a.636.636 0 0 1-.636-.636c0-.854-.696-1.55-1.548-1.55-.853 0-1.548.696-1.548 1.55a.636.636 0 0 1-.637.636h-2.935v3.097Zm10.876 1.274H10.24a.636.636 0 0 1-.637-.637v-4.37c0-.353.285-.638.637-.638h3.006a2.828 2.828 0 0 1 2.75-2.185c1.336 0 2.46.935 2.75 2.185h3.006c.352 0 .636.285.636.638v4.37a.637.637 0 0 1-.636.637ZM9.562 14.3a.635.635 0 0 1-.471-.209l-1.182-1.3a.636.636 0 1 1 .943-.855l.688.756 2.069-2.505a.638.638 0 0 1 .982.81l-2.538 3.072a.64.64 0 0 1-.476.232h-.015ZM9.562 20.923a.635.635 0 0 1-.471-.209l-1.182-1.3a.636.636 0 1 1 .943-.856l.688.757 2.069-2.506a.636.636 0 1 1 .982.811l-2.538 3.072a.637.637 0 0 1-.476.23h-.015ZM9.562 27.545a.635.635 0 0 1-.471-.209l-1.182-1.3a.636.636 0 0 1 .943-.856l.688.756 2.069-2.505a.636.636 0 1 1 .982.811l-2.538 3.072a.638.638 0 0 1-.476.231h-.015ZM23.483 13.075H15.1a.637.637 0 1 1 0-1.274h8.383a.636.636 0 1 1 0 1.274ZM23.483 19.721H15.1a.636.636 0 1 1 0-1.274h8.383a.637.637 0 1 1 0 1.274ZM23.483 26.37H15.1a.636.636 0 1 1 0-1.274h8.383a.637.637 0 1 1 0 1.273Z",
    fill: "#3461FD"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNote);
export default __webpack_public_path__ + "static/media/note.5ee484a0c8f746e33d6042022a535f76.svg";
export { ForwardRef as ReactComponent };